import { cn } from "../../lib/utils";

type Props = {
  symbol: string;
  logo: string;
  size?: number;
  className?: string;
};

export default function TokenAvatar({
  symbol,
  logo,
  size = 40,
  className,
}: Props) {
  const style = {
    width: size,
    height: size,
  };

  return (
    <img
      key={symbol}
      src={logo}
      alt={`${symbol}`}
      width={size}
      height={size}
      style={style}
      className={cn("rounded-full bg-secondary", className)}
      loading="lazy"
    />
  );
}
